import { Component, OnInit } from '@angular/core';
import { LoopBackAuth, UserDataApi } from '../../../../assets/js/lb-sdk';

@Component({
  selector: 'app-account-verified',
  templateUrl: './account-verified.component.html',
  styleUrls: ['./account-verified.component.css']
})
export class AccountVerifiedComponent implements OnInit {

  constructor(
    private loopBackAuth: LoopBackAuth,
    private userDataApi: UserDataApi
  ) { }

  ngOnInit() {
    if (this.getUser()) {
      this.userDataApi
        .logout()
        .subscribe(
          () => {
            this.loopBackAuth.clear();
            localStorage.removeItem('orders');
          }
        );
    }
  }

  getUser() {
    return this.loopBackAuth.getToken() ? this.loopBackAuth.getCurrentUserData() : undefined;
  }
}
